/**
 * PostHog Analytics Configuration
 * 
 * Centralized PostHog initialization.
 * Uses environment variables for configuration.
 */

import posthog from 'posthog-js';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

const isValidConfig = posthogKey && 
  posthogKey !== 'your_posthog_project_api_key_here' && 
  posthogKey.trim() !== '';

if (isValidConfig) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: 'identified_only', // Recommended for privacy and cost control
    capture_pageview: true,              // Automatically track page views
    persistence: 'localStorage',         // Use localStorage for storing visitor ID
    autocapture: true,                  // Automatically capture clicks/inputs for heatmap/session replay
  });
} else {
  console.warn(
    '[PostHog] Environment variables are not set or contain placeholders. ' +
    'Please set REACT_APP_POSTHOG_KEY in your .env.local file to enable analytics.'
  );
}

export { posthog };
